<template>
    <div class="image_saver_view">
        <!-- 标题栏 -->
        <div class="image_saver_view_title" v-show="!((item.list.length==0 && itemsLength==1)||isShowCard)">
            <!-- 域名图标 -->
            <div class="image_saver_view_icon" :style="faviconStyle">
                <img ref="faviconIcon" class="image_saver_view_favicon" :src="item.favicon" @error="faviconError($event,item.source)" />
            </div>
            <!-- 域名文字 -->
            <div class="image_saver_view_domain">{{ (item.type=='google'?'Google Search Images -- ':'') + item.domain }} - {{ (item.typeSub=='posts' && item.posts) ? postsUnitText(item.posts) : filesUnitText(item.list.length) }}</div>
            <!-- 下载所有 -->
            <div class="image_saver_view_download_all" @click.stop="downloads" v-if="item.list.length > 0">
                <img v-show="isDownloadAllRequest" class="my_animation" src="../../assets/images/imageSaver/loadingBlue.png" />
                <img v-show="!isDownloadAllRequest" src="../../assets/images/imageSaver/downloadAll.svg" />
                <span>{{ $t('language.imageSaver.downloadAll') }}</span>
            </div>
            <!-- 保存所有 -->
            <div class="image_saver_view_save_all" @click.stop="saveAll" v-if="item.list.length > 0">
                <img src="../../assets/images/imageSaver/saveAll.svg" />
                <span>{{ $t('language.imageSaver.saveAll') }}</span>
            </div>
        </div>
        <!-- 图片栏 -->
        <div class="image_saver_view_imgs" v-show="item.list.length>0" :style="{minHeight:imgsBoxMinHeight+'px',maxHeight:imgsBoxMaxHeight+'px',padding:'10px 30px 10px 30px'}" :data-ivs="isVerticalScreen?'Y':'N'">
            <!-- Instagram卡片 -->
            <div class="ins_card" v-if="isShowCard" :data-loading="item.loading?'Y':'N'" :data-error="item.isError?'Y':'N'">
                <!-- 头像 -->
                <div class="ins_card_user_icon">
                    <img :src="item.favicon" />
                    <div class="ins_card_mask"></div>
                    <div @click="saveAvatar()" class="ins_card_icon_save">{{ $t('language.imageSaver.saveToCloud') }}</div>
                    <div @click="downloadAvatar()" class="ins_card_icon_download">{{ $t('language.imageSaver.download') }}</div>
                </div>
                <!-- 用户信息 -->
                <div class="ins_card_user_info">
                    <!-- 用户名 -->
                    <div class="ins_card_username">{{ item.domain }}</div>
                    <!-- 统计 -->
                    <div class="ins_card_user_count">
                        <div class="ins_card_user_posts">
                            <div class="ins_card_user_num">{{ item.posts==undefined ? '-' : item.posts }}</div>
                            <div class="ins_card_user_text">{{ $t('language.imageSaver.insCardPosts') }}</div>
                        </div>
                        <div class="ins_card_user_followers">
                            <div class="ins_card_user_num">{{ item.followed==undefined ? '-' : item.followed }}</div>
                            <div class="ins_card_user_text">{{ $t('language.imageSaver.insCardFollowers') }}</div>
                        </div>
                        <div class="ins_card_user_following">
                            <div class="ins_card_user_num">{{ item.follow==undefined ? '-' : item.follow }}</div>
                            <div class="ins_card_user_text">{{ $t('language.imageSaver.insCardFollowing') }}</div>
                        </div>
                    </div>
                    <!-- 按钮 -->
                    <div class="ins_card_btns">
                        <div @click="saveAll" class="ins_card_save_all">{{ saveAllBtnText }}</div>
                        <div @click="downloads" class="ins_card_downlad_all">{{ downloadAllBtnText + insCountStr }}</div>
                    </div>
                </div>
                <!-- 没有分类时的间隔 -->
                <div class="ins_card_types_no" v-if="!isShowInsTab"></div>
                <!-- 分类 -->
                <div class="ins_card_types" v-if="isShowInsTab">
                    <div @click="selectInsType(index,'posts')" class="ins_card_type_posts" :class="insTypeSelect=='posts'?'select':''">
                        <span>{{ $t('language.imageSaver.insTabPosts') }}</span>
                    </div>
                    <div @click="selectInsType(index,'reels')" class="ins_card_type_reels" :class="insTypeSelect=='reels'?'select':''">
                        <span>{{ $t('language.imageSaver.insTabReels') }}</span>
                    </div>
                    <div @click="selectInsType(index,'stories')" class="ins_card_type_stories" :class="insTypeSelect=='stories'?'select':''">
                        <span>{{ $t('language.imageSaver.insTabStories') }}</span>
                    </div>
                    <div @click="selectInsType(index,'highlights')" class="ins_card_type_highlights" :class="insTypeSelect=='highlights'?'select':''">
                        <span>{{ $t('language.imageSaver.insTabHighlights') }}</span>
                    </div>
                </div>
            </div>
            <!-- 附加数据是否加载失败 -->
            <div class="ins_sub_error" v-if="item.isError" :style="{height:(noImageHeight-402)+'px'}">
                <div class="ins_sub_error_content">
                    <img v-if="item.msg!='no_data'" draggable="false" src="../../assets/images/imageSaver/previewError.svg" />
                    <img v-if="item.msg=='no_data'" draggable="false" src="../../assets/images/imageSaver/imageNo.svg" />
                    <div>{{item.msg=='no_data' ? $t('language.imageSaver.noImage') : $t('language.common.failed')}}</div>
                </div>
            </div>
            <!-- 附加数据加载中 -->
            <div class="ins_sub_loading" v-if="item.loading" :style="{height:(noImageHeight-402)+'px'}">
                <div class="ins_sub_loading_icon"></div>
            </div>
            <!-- 上一页 -->
            <div class="page_up" v-if="item.pageIndex>1">
                <button class="page_up_btn" @click="pageUp">Previous</button>
            </div>
            <!-- 单个图片 -->
            <div class="image_saver_view_img" v-if="!item.loading && !item.isError" v-for="bean of listSub" :data-status="bean.status" :data-type="bean.type" :data-canplay="bean.canplay" @mouseenter="enterVideoPreview(bean)" @mouseleave="leaveVideoPreview(bean)">
                <!-- 预览图 -->
                <img class="view" :class="'imagesaver_' + item.type"
                    :src="isPreview ? (bean.preview ? bean.preview.data : previewInsImg) : bean.url"
                    @error="previewError($event,bean)"
                    @load="imgLoadSucess(bean)"
                    :style="{width:viewImgWigth+'px',height:(viewImgWigth+(isVerticalScreen?200:0))+'px'}" />
                <!-- 视频预览 -->
                <video class="preview_error video_preview" v-if="bean.type=='video' && bean.videoPreview" autoplay loop @canplay="handleCanplay(bean)">
                    <source :src="bean.videoPreview" type="video/mp4">
                </video>
                <!-- 预览图加载动画 -->
                <el-skeleton class="preview_error skeleton" animated>
                    <template slot="template">
                        <el-skeleton-item :style="{width:viewImgWigth+'px',height:(viewImgWigth+(isVerticalScreen?200:0))+'px'}" />
                    </template>
                </el-skeleton>
                <!-- 蒙版 -->
                <div class="preview_error mask"></div>
                <!-- 上传图标 -->
                <div class="preview_error save" @click="save(bean)"></div>
                <!-- 上传文字 -->
                <div class="preview_error text_upload" @click="save(bean)">{{ $t('language.imageSaver.saveToCloud') }}</div>
                <!-- 下载图标 -->
                <div class="preview_error download" @click="download(bean)"></div>
                <!-- 下载文字 -->
                <div class="preview_error text_download" @click="download(bean)">{{$t('language.imageSaver.download')}}</div>
                <!-- 视频图标 -->
                <div class="preview_error type_video" v-if="bean.type=='video'"></div>
            </div>
            <!-- 加载更多 -->
            <div class="load_more_box" v-if="item.next || canClickLoadMore">
                <button @click="loadMore" v-if="item.type == 'instagram'" class="loadMore">
                    <img v-if="isLoading" class="my_animation" src="../../assets/images/imageSaver/loadingBlue.png" />
                    <span>{{ $t('language.imageSaver.loadMore') }}</span>
                </button>
            </div>
        </div>
        <!-- 没有任何图片 -->
        <div class="image_saver_view_blank" v-if="item.list.length==0" :style="{ height: noImageHeightFinally + 'px' }">
            <div class="image_saver_view_blank_body">
                <img draggable="false" src="../../assets/images/imageSaver/imageNo.svg" />
                <div class="image_saver_view_blank_body_text">{{ $t('language.imageSaver.noImage') }}</div>
                <div class="image_saver_view_blank_body_dest">{{ $t('language.imageSaver.notSupport') }}</div>
            </div>
        </div>
        <!-- 保存目的地弹窗 -->
        <transferAimsDialog ref="transferAimsDialog"></transferAimsDialog>
        <!-- 付费用户升级 -->
        <upgradeVipDialog ref="upgradeVipDialog"></upgradeVipDialog>
        <!-- 免费用户升级 -->
        <upgradeNewDialog ref="upgradeNewDialog"></upgradeNewDialog>
    </div>
</template>

<script>
import Vue from 'vue';
import commonUtils from "@/js/workspace/common_util.js";
import upgradeVipDialog from "@/components/popup/upgrade_popups/upgrade_account_vip_popup";
import upgradeNewDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";
import transferAimsDialog from "@/components/popup/cloud_transfer_popups/task_single_popup";
import taskListUtils from "@/js/workspace/task_list_util.js";
import commonstate from '@/js/constant.js';

export default {
    name: "imageSaverView",
    props: ['inputHeight', 'itemsLength', 'item', 'isPreview', 'index', 'addInstagramItems', 'node', 'updateTaskDestDrive', 'viewImgWigth', 'lineCount', 'noImageHeight', 'selectInsType', 'insTypeSelect', 'initTypeSub', 'pageUpOrDown'],
    components: {
        transferAimsDialog,
        upgradeVipDialog,
        upgradeNewDialog,
    },
    data() {
        return {
            // 加载更多
            isLoading: false,
            // 选择目的地文件夹弹窗确定时，判断需要用到
            pageName:'imageSaver',
            // 没有设置目的地文件夹的时候，提交数据时缓存处理
            tempData: [],
            // 临时提交数据，是否是提交全部
            tempIsAll: false,
            // 没有域名图标的替换
            undefinedFavicon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAfJJREFUOE+d1UuojmEQB/DfWdkQG2VHLrFxKbfcConkUhYUNpKFy8ZCWBAiKZ1s3DeKWFAWzlEuGyVKSdiKbFAWsrVQ3tEzenp7v++cTD31fc/M82/mP/+Zd0C3jcE2zClnbgl7h/fl3MWv9vOBDrwZuIw1Hb59WIjNeIv9+FDHtQE3YqhH1nF9CIOYinPYik0Yzjc14F5c6QP2DKta/g0FLDK/Gr4EXIoXfcDC1QUY99NL2cvwMgDH4jnm9QE8jPMlZkIBr8MPYA9WBOAO3B4hu5+lCcHd5I7Y6PikKDsAT+PYCIDp3t0A3mjFLolSy92ZAHxQSriPXTjRevAR08pdWxXjS1OWF/9wBHxpSN1ZQIOLixXgqeb3yUZK8/G6amKGXCpazP/fEvBok8UtbGkmIzLtklVo7l4r+++YWN19zZIjy9DSODzF4qrEKQ0Vn3twfAEHK99QNmV1AxQ6StuOOx2ld+FGhyP7sMGUzTXMKnzmo5UNr3GySTGS1+sxK4ELcBYzcbwW9hMcaaUQDam7/qOUGHzXNruZ75sp7HDk6MWaivWUtg6POuqs5bMWjwtlf0cvLZdDbJyH1X3wEzyl/VsE6LkcMjjXV8gjpPSpOOrSI4lRra8EzQW7CK/K+V1xGXO/vlmyb0azYBP0vz8BfwDcOWck1+6gDQAAAABJRU5ErkJggg==',
            // 这是一个透明图片，Instagram预览图加载前占位
            previewInsImg: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkVFRTM3MDUyMThGRDExRUZCRUQ4Q0MyNzRERkVFM0UzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkVFRTM3MDUzMThGRDExRUZCRUQ4Q0MyNzRERkVFM0UzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RUVFMzcwNTAxOEZEMTFFRkJFRDhDQzI3NERGRUUzRTMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RUVFMzcwNTExOEZEMTFFRkJFRDhDQzI3NERGRUUzRTMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5Exga6AAAAFUlEQVR42mL8//8/AwgwMUABQIABADAGAwGo78J/AAAAAElFTkSuQmCC',
            // 预览失败替换图片
            previewErrorImg: require('@/assets/images/imageSaver/previewError.svg'),
            // 是否正在保存所有
            isSaveAllRequest: false,
            // 是否正在下载所有
            isDownloadAllRequest: false,
            // 图片预览每页最大数
            pageMax: 100,
        };
    },
    mounted() {
        // 如果未设置云盘目的地
        if (!this.node) {
            // 则实时检测是否有缓存任务
            this.imageSaverAddTempTask = setInterval(() => {
                if (this.node && this.tempData.length > 0) {
                    // 检测到缓存任务，并提交
                    this.saveRequest(this.tempIsAll, this.tempData, null);
                    // 清理缓存任务
                    this.tempData = [];
                    this.tempIsAll = false;
                } else if (this.node && this.tempData.length == 0) {
                    // 已完成缓存任务提交，清理定时器
                    clearInterval(this.imageSaverAddTempTask);
                } else {
                    // 持续检测是否有缓存任务
                }
            }, 500);
        }
    },
    beforeDestroy() {
        // 清理定时器
        clearInterval(this.imageSaverAddTempTask);
    },
    activated() {
        // 刷新Ins统计
        this.refreshInsCount();
    },
    computed: {
        // Ins个数统计信息
        insCountStr() {
            var insCount = this.item.insCount;
            if (insCount && this.item.typeSub!='single') {
                if (insCount.total) {
                    return ' (' + insCount.less + '/' + insCount.total + ' Left)';
                } else {
                    return '';
                }
            } else {
                return '';
            }
        },
        // 保存所有按钮文字
        saveAllBtnText() {
            var typeSub = this.item.typeSub;
            if (typeSub == 'single') {
                if (this.item.list.length==1 && this.item.list[0].type=='video') {
                    return this.$t('language.imageSaver.saveInsVideo');
                } else {
                    return this.$t('language.imageSaver.saveSinglePost');
                }
            }
            if (typeSub == 'posts') return this.$t('language.imageSaver.saveAllPosts');
            if (typeSub == 'reels') return this.$t('language.imageSaver.saveAllReels');
            if (typeSub == 'stories') return this.$t('language.imageSaver.saveAllStories');
            if (typeSub == 'highlights') return this.$t('language.imageSaver.saveAllHighlights');
            return this.$t('language.imageSaver.saveAll');
        },
        // 下载所有按钮文字
        downloadAllBtnText() {
            var typeSub = this.item.typeSub;
            if (typeSub == 'single') {
                if (this.item.list.length==1 && this.item.list[0].type=='video') {
                    return this.$t('language.imageSaver.downloadInsVideo');
                } else {
                    return this.$t('language.imageSaver.downloadSinglePost');
                }
            }
            if (typeSub == 'posts') return this.$t('language.imageSaver.downloadAllPosts');
            if (typeSub == 'reels') return this.$t('language.imageSaver.downloadAllReels');
            if (typeSub == 'stories') return this.$t('language.imageSaver.downloadAllStories');
            if (typeSub == 'highlights') return this.$t('language.imageSaver.downloadAllHighlights');
            return this.$t('language.imageSaver.downloadAll');
        },
        // 是否是竖屏
        isVerticalScreen() {
            if (this.insTypeSelect == 'reels') return true;
            return false;
        },
        // 是否显示卡片
        isShowCard() {
            return this.item.type == 'instagram';
        },
        // 是否显示InsTab
        isShowInsTab() {
            return this.initTypeSub == 'posts';
            // var typeSub = this.item.typeSub;
            // if (typeSub == 'posts') return true;
            // if (typeSub == 'reels') return true;
            // if (typeSub == 'stories') return true;
            // if (typeSub == 'highlights') return true;
            // return false;
        },
        // 可以点击加载更多
        canClickLoadMore() {
            return this.item.pageIndex*this.pageMax < this.item.list.length;
        },
        // 当前页数据
        listSub() {
            var result = [];
            var list = this.item.list;
            var start = (this.item.pageIndex - 1) * this.pageMax;
            for (var i=start; i<list.length&&result.length<this.pageMax; i++) {
                result.push(list[i]);
            }
            return result;
        },
        // 网站图标特殊处理
        faviconStyle() {
            var style = {};
            if (this.item.type == 'instagram') {
                if (this.item.favicon.indexOf('svg+xml') == -1) {
                    style.borderRadius = '12px';
                    style.border = '1px solid #C1CBE3';
                }
            }
            return style;
        },
        // 所有图片外框最小高
        imgsBoxMinHeight() {
            var isShowTitle = !((this.item.list.length==0 && this.itemsLength==1)||this.isShowCard);
            return this.noImageHeight - 43 - (isShowTitle?70:0);
        },
        // 所有图片外框最大高
        imgsBoxMaxHeight() {
            // 确定行数
            var line = this.listSub.length / this.lineCount;
            if (this.listSub.length%this.lineCount != 0) {
                line++;
            }
            // viewImgWigth：由于预览图是正方形，所以宽就是高
            // line：总预览图行数
            // 1000：懒得调整准确高度，反正是最大高，所以多加1000
            return (this.viewImgWigth+(this.isVerticalScreen?200:0)) * line + 1000;
        },
        // 没有图片的最终高度
        noImageHeightFinally() {
            if (this.item.list.length==0 && this.itemsLength!=1) {
                // 多个结果集时固定高度
                return 337;
            } else {
                // 单个结果集时动态高度，输入框高度变化时需要处理
                return this.noImageHeight - this.inputHeight - 1;
            }
        }
    },
    methods: {
        // 贴子单位字符串
        postsUnitText(num) {
            if (num > 1) {
                return num + ' ' + this.$t('language.imageSaver.posts');
            } else {
                return num + ' ' + this.$t('language.imageSaver.post');
            }
        },
        // 文件数单位字符串
        filesUnitText(num) {
            if (num > 1) {
                return num + ' ' + this.$t('language.imageSaver.taskUnitFiles');
            } else {
                return num + ' ' + this.$t('language.imageSaver.taskUnitFile');
            }
        },
        // 刷新Ins统计
        refreshInsCount() {
            if (this.item.insCount) {
                taskListUtils.imageSaverRequest("/insCount", {}, res => {
                    if (res.code == 200) {
                        this.item.insCount = res.data;
                    }
                });
            }
        },
        // 准备头像相关参数
        createAvatarParam() {
            var tempBean = {};
            tempBean.type = 'image';
            tempBean.url = this.item.faviconURL;
            tempBean.filename = this.item.domain + '.jpg';
            tempBean.preview = {data:this.item.favicon};
            return tempBean;
        },
        // 保存头像
        saveAvatar() {
            this.save(this.createAvatarParam());
        },
        // 下载头像
        downloadAvatar() {
            this.download(this.createAvatarParam());
        },
        // 上一页
        pageUp() {
            if (this.item.pageIndex > 1) {
                this.pageUpOrDown(this.index, 'up', this.item.typeSub);
            }
        },
        // 字符串Base64编码
        toBase64(str) {
            // 创建一个 TextEncoder 实例
            const encoder = new TextEncoder();
            // 将字符串转换为一个 Uint8Array
            const byteArray = encoder.encode(str);
            // 转Base64
            let binary = '';
            const len = byteArray.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(byteArray[i]);
            }
            return btoa(binary);
        },
        // 创建视频预览链接
        createVideoPreviewUrl(url) {
            const base64 = this.toBase64(url);
            return commonstate.apiUrl + '/imagesaver/previewVideo?base64=' + base64;
        },
        // 鼠标进入时预览
        enterVideoPreview(bean) {
            if (bean.type == 'video') {
                // 进入
                Vue.set(bean, 'hover', "yes");
                if (!bean.videoPreview) {
                    // 加载
                    Vue.set(bean, 'videoPreview', this.createVideoPreviewUrl(bean.url));
                }
            }
        },
        // 鼠标离开时移除预览
        leaveVideoPreview(bean) {
            if (bean.type == 'video') {
                // 离开
                Vue.delete(bean, 'hover');
                if (bean.canplay) {
                    // 销毁
                    Vue.delete(bean, 'videoPreview');
                    Vue.delete(bean, 'canplay');
                }
            }
        },
        // 视频已加载好
        handleCanplay(bean) {
            if (bean.type == 'video') {
                if (bean.hover) {
                    // 完毕
                    Vue.set(bean, 'canplay', "yes");
                } else {
                    // 放弃
                    Vue.delete(bean, 'videoPreview');
                    Vue.delete(bean, 'canplay');
                }
            }
        },
        // 错误提示
        errorTips(msg) {
            this.$toast({
                text: msg,
                type: 'fail',
                idValue: "allBox"
            });
        },
        // 预览失败处理
        previewError(event, bean) {
            event.target.src = this.item.type=='instagram' ? this.previewInsImg : this.previewErrorImg;
            Vue.set(bean, 'status', 'error');
        },
        // 预览加载成功
        imgLoadSucess(bean) {
            if (this.item.type != 'instagram') {
                if (!bean.status) {
                    Vue.set(bean, 'status', 'success');
                }
            }
        },
        // 加载网址图标
        faviconError(event,url) {
            event.target.src = this.undefinedFavicon;
            taskListUtils.imageSaverRequest("/getFavicon", { urls: [url] }, res => {
                if (res.code == 200) {
                    event.target.src = res.data;
                }
            });
        },
        // 设置选择的Node
        setNode(node) {
            this.updateTaskDestDrive(node);
        },
        // 下载
        download(bean) {
            this.downloadsRequest(false, [bean], null);
            // GA
            var type = this.item.type;
            if (type == 'instagram') taskListUtils.imageSaverRequest("/ga", {gaType:'ins_down_one'});
            if (type == 'google') taskListUtils.imageSaverRequest("/ga", {gaType:'google_down_one'});
            if (type == 'web') taskListUtils.imageSaverRequest("/ga", {gaType:'web_down_one'});
        },
        // 下载所有
        downloads() {
            if (this.item.loading || this.item.isError) return;
            if (this.item.type == 'instagram') {
                // 有下一页标识 或者 加载过下一页 或者 不是单贴子
                if (this.item.next || this.item.isLoadedNext || this.item.typeSub!='single') {
                    if (this.item.list.length==1 && !this.item.next) {
                        // 如果只有1个则直接下载
                        this.downloadsRequest(true, this.item.list, this.item.next);
                    } else {
                        // 创建任务下载所有
                        this.downloadsTaskRequest();
                    }
                } else {
                    // 直接下载所有
                    this.downloadsRequest(true, this.item.list, this.item.next);
                }
            } else {
                // 过滤掉加载失败的
                var noError = [];
                var list = this.item.list;
                for (var i=0; i<list.length; i++) {
                    if (list[i].status != 'error') {
                        noError.push(list[i]);
                    }
                }
                if (noError.length == 0) {
                    this.errorTips('There is no normal images.');
                    return;
                } else {
                    // 直接下载所有
                    this.downloadsRequest(true, noError, this.item.next);
                }
            }
            // GA
            var type = this.item.type;
            if (type == 'instagram') taskListUtils.imageSaverRequest("/ga", {gaType:'ins_down_all'});
            if (type == 'google') taskListUtils.imageSaverRequest("/ga", {gaType:'google_down_all'});
            if (type == 'web') taskListUtils.imageSaverRequest("/ga", {gaType:'web_down_all'});
        },
        // 下载请求
        downloadsRequest(isAll, list, next) {
            if (isAll && this.isDownloadAllRequest) return;
            if (isAll) this.isDownloadAllRequest = true;
            taskListUtils.imageSaverRequest("/downloadsReady", { typeSub:this.item.typeSub, type: this.item.type, source:this.item.source, domain:this.item.domain, next:next, list: list }, res => {
                if (isAll) {
                    setTimeout(() => {
                        this.isDownloadAllRequest = false;
                    }, 2000);
                }
                if (res.code == 200) {
                    location.href = commonstate.apiUrl + "/imagesaver/downloads?uuid=" + res.data;
                } else {
                    this.errorTips(res.message);
                }
            });
        },
        // 下载所有创建任务
        downloadsTaskRequest() {
            // 检测个数是否足够，并弹窗
            if (this.item.insCount) {
                var less = this.item.insCount.less;
                var total = this.item.insCount.total;
                if (total>0 && less<=0) {
                    let user = commonUtils.getUser();
                    if (user.vip) {
                        var upgradeVipDialog = this.$refs.upgradeVipDialog;
                        upgradeVipDialog.title = this.$t('language.paySystem.supportItem.vipPopupTitleIns');
                        upgradeVipDialog.desc = this.$t('language.paySystem.supportItem.vipPopupDescIns');
                        upgradeVipDialog.isShow = true;
                    } else {
                        var upgradeNewDialog = this.$refs.upgradeNewDialog;
                        upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_ins');
                        upgradeNewDialog.curItem = 'ins';
                        upgradeNewDialog.isShow = true;
                    }
                    return;
                }
            }
            // 二级参数准备
            var bean = {};
            bean.type = "download_all";
            bean.url = this.item.domain + '-' + this.item.typeSub;
            bean.pre = this.$refs.faviconIcon.src;
            // 一级参数准备
            var data = {};
            // 准备参数前提
            var item = this.item;
            // 设置参数
            data.type = item.type;
            data.source = item.source;
            if (this.item.next) {
                data.next = this.item.next;
            }
            data.toType = 'none';
            data.toPath = 'none';
            data.toFolder = 'none';
            data.list = [bean];
            // 贴子数或文件数
            if (item.typeSub=='posts' && item.posts) {
                data.sumPosts = item.posts;
                data.toFolder = ''+item.posts;
            } else {
                data.sumCount = item.list.length;
                data.toPath = ''+item.list.length;
            }
            // Ins用户ID
            if (item.insId) {
                data.insUserId = parseInt(item.insId);
            }
            // 开始请求
            taskListUtils.imageSaverRequest("/createTask", data, res => {
                if (res.code == 200) {
                    // 添加任务到列表
                    commonUtils.addImageSaverTask([res.data]);
                    // 刷新Ins统计
                    this.refreshInsCount();
                    // 新手引导
                    this.checkNoviceGuidance();
                    // 查看任务时，直接到对应Tab
                    this.$cookies.set("imagesaverTaskTab", 'downloadAll', "1y");
                } else if (res.message == 'exist') {
                    this.errorTips(this.$t('language.imageSaver.insDownloadExist'));
                } else {
                    this.errorTips(res.message);
                }
            });
        },
        // 保存
        save(bean) {
            this.saveRequest(false, [bean], null);
            // GA
            var type = this.item.type;
            if (type == 'instagram') taskListUtils.imageSaverRequest("/ga", {gaType:'ins_upload_one'});
            if (type == 'google') taskListUtils.imageSaverRequest("/ga", {gaType:'google_upload_one'});
            if (type == 'web') taskListUtils.imageSaverRequest("/ga", {gaType:'web_upload_one'});
        },
        // 保存所有
        saveAll() {
            if (this.item.loading || this.item.isError) return;
            var data = {};
            data.type = "all";
            if (this.item.type == 'instagram') {
                data.url = this.item.domain + '-' + this.item.typeSub;
            } else {
                data.url = this.item.domain;
            }
            data.pre = this.$refs.faviconIcon.src;
            if (this.item.type == 'google' || this.item.type == 'web') {
                // 过滤掉加载失败的
                var noError = [];
                var list = this.item.list;
                for (var i=0; i<list.length; i++) {
                    if (list[i].status != 'error') {
                        noError.push(list[i]);
                    }
                }
                if (noError.length == 0) {
                    this.errorTips('There is no normal images.');
                    return;
                } else {
                    data.list = noError;
                }
            }
            this.saveRequest(true, [data], null);
            // GA
            var type = this.item.type;
            if (type == 'instagram') taskListUtils.imageSaverRequest("/ga", {gaType:'ins_upload_all'});
            if (type == 'google') taskListUtils.imageSaverRequest("/ga", {gaType:'google_upload_all'});
            if (type == 'web') taskListUtils.imageSaverRequest("/ga", {gaType:'web_upload_all'});
        },
        // 保存请求
        saveRequest(isAll, list, next) {
            if (isAll && this.isSaveAllRequest) return;
            // 流量检测
            if (this.showNoTrafficPopup()) return;
            // 弹出目的地设置，缓存任务
            if (!this.node) {
                this.$refs.transferAimsDialog.taskSingleShow = true;
                this.tempData = list;
                this.tempIsAll = isAll;
                return;
            }
            // 准备参数
            var data = {};
            // 准备参数前提
            var node = this.node;
            var item = this.item;
            // 设置参数
            data.type = item.type;
            data.source = item.source;
            data.next = next;
            data.toId = node.id;
            data.toType = node.type;
            data.toPath = node.path;
            data.toFolder = node.folder;
            data.list = list;
            // 贴子数或文件数
            if (item.typeSub=='posts' && item.posts) {
                data.sumPosts = item.posts;
            } else {
                data.sumCount = item.list.length
                // 过滤了加载失败的
                if (this.item.type == 'google' || this.item.type == 'web') {
                    if (list[0].list) {
                        data.sumCount = list[0].list.length;
                    }
                }
            }
            // Ins用户ID
            if (item.insId) {
                data.insUserId = parseInt(item.insId);
            }
            // 直接请求
            if (isAll) this.isSaveAllRequest = true;
            taskListUtils.imageSaverRequest("/createTask", data, res => {
                if (isAll) this.isSaveAllRequest = false;
                if (res.code == 200) {
                    if (list.length == 1) {
                        // 单个保存和保存所有都只有一条记录
                        commonUtils.addImageSaverTask([res.data]);
                    } else {
                        // saveAll没有提交【this.item.list】所以不会有这种情况
                        commonUtils.addImageSaverTask(res.data);
                    }
                    // 新手引导
                    this.checkNoviceGuidance();
                    // 查看任务时，直接到对应Tab
                    this.$cookies.set("imagesaverTaskTab", (isAll ? 'saveAll' : 'saveOne'), "1y");
                } else if (res.message == 'exist') {
                    this.errorTips(this.$t('language.imageSaver.insDownloadExist'));
                } else {
                    this.errorTips(res.message);
                }
            });
        },
        // 新手引导
        checkNoviceGuidance() {
            // 现有任务个数
            let taskCount = this.$store.getters.getImageSaverTaskAllCount;
            // 刚刚创建了任务，任务总数是1
            if (taskCount == 1) {
                // 获取用户
                let user = commonUtils.getUser();
                // 以前是否显示过新手引导
                let hasBeenShow = localStorage.getItem("insGuideFlag"+user.id);
                // 没有显示过
                if (!hasBeenShow) {
                    // 标记显示过
                    localStorage.setItem("insGuideFlag"+user.id,true);
                    // 显示新手引导
                    this.$store.state.insGuideFlag = true;
                }
            }
        },
        // 是否显示没有流量弹窗
        showNoTrafficPopup() {
            let user = commonUtils.getUser();
            if (user.totalBytes != -1 && user.usedBytes >= user.totalBytes) {
                if (user.vip) {
                    var upgradeVipDialog = this.$refs.upgradeVipDialog;
                    upgradeVipDialog.title = this.$t('language.paySystem.supportItem.vipPopupTitleTraffic');
                    upgradeVipDialog.desc = this.$t('language.paySystem.supportItem.vipPopupDescTraffic');
                    upgradeVipDialog.isShow = true;
                } else {
                    var upgradeNewDialog = this.$refs.upgradeNewDialog;
                    upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
                    upgradeNewDialog.curItem = 'traffic';
                    upgradeNewDialog.isShow = true;
                }
                return true;
            }
            return false;
        },
        // 加载更多
        loadMore() {
            // 缓存加载
            if (this.canClickLoadMore) {
                this.pageUpOrDown(this.index, 'down', this.item.typeSub);
                return;
            }
            // 真加载
            var url = this.item.source;
            var start = this.item.next;
            if (start != null && start != '') {
                this.isLoading = true;
                taskListUtils.imageSaverRequest("/decodeInstagram", { urls: [url], starts: [start] }, res => {
                    this.isLoading = false;
                    if (res.code == 200) {
                        var data = res.data[0];
                        this.addInstagramItems(this.index, data, this.item.typeSub);
                    } else {
                        this.errorTips(res.message);
                    }
                });
            }
        },
    }
};
</script>

<style>
/* 标题栏 */
.image_saver_view_title {
    height: 70px;
    background-color: #F9FBFE;
    position: sticky;
    z-index: 4;
    top: 0px;
}

/* 域名图标外框 */
.image_saver_view_icon {
    width: 24px;
    height: 24px;
    margin-left: 20px;
    display: inline-block;
    vertical-align: middle;
    box-sizing: border-box;
    overflow: hidden;
}

/* 域名图标 */
.image_saver_view_favicon {
    width: 24px;
    height: 24px;
}

/* 域名文字 */
.image_saver_view_domain {
    font-size: 20px;
    font-weight: bold;
    display: inline-block;
    height: 70px;
    line-height: 70px;
    vertical-align: middle;
    margin-left: 16px;
    max-width: calc(100% - 400px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

/* 下载所有、保存所有 */
.image_saver_view_download_all,
.image_saver_view_save_all {
    cursor: pointer;
    font-size: 14px;
    color: #5562B4;
    float: right;
    height: 30px;
    line-height: 30px;
    margin-right: 20px;
    margin-top: 20px;
    padding: 0 10px;
}

/* 下载所有、保存所有 按钮背景 */
.image_saver_view_download_all:hover,
.image_saver_view_save_all:hover {
    background: rgba(80, 101, 187, 0.05);
}

/* 所有图片外框 */
.image_saver_view_imgs {
    background-color: #FFF;
    overflow: hidden;
}

/* 清除高度塌陷 */
.image_saver_view_imgs::after {
    content: "";
    display: block;
    clear: both;
}

/* 预览图外框 */
.image_saver_view_img {
    float: left;
    margin: 10px;
    overflow: hidden;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.03);
    position: relative;
}

/* 预览图 */
.image_saver_view_img>.view {
    position: relative;
}

.image_saver_view_img>.imagesaver_web {
    object-fit: scale-down;
}

.image_saver_view_img>.imagesaver_instagram {
    object-fit: cover;
}

.image_saver_view_img>.imagesaver_google {
    object-fit: contain;
}

.image_saver_view_img[data-status=error]>.imagesaver_web,
.image_saver_view_img[data-status=error]>.imagesaver_instagram,
.image_saver_view_img[data-status=error]>.imagesaver_google {
    object-fit: scale-down;
}

/* 默认隐藏：视频预览、蒙版、保存、文字、下载 */
.image_saver_view_img>.video_preview,
.image_saver_view_img>.mask,
.image_saver_view_img>.save,
.image_saver_view_img>.text_upload,
.image_saver_view_img>.text_download,
.image_saver_view_img>.download {
    display: none;
}

/* 图片预览骨架 */
.image_saver_view_img>.skeleton {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 3;
    left: 0px;
    top: 0px;
}

/* 预览图蒙版 */
.image_saver_view_img:hover>.mask {
    display: block;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    z-index: 1;
    left: 0px;
    top: 0px;
}

/* 保存到云图标 和 下载图标 */
.image_saver_view_img:hover>.save,
.image_saver_view_img:hover>.download {
    width: 50%;
    height: 169px;
    background-position: center;
    background-repeat: no-repeat;
    display: block;
    cursor: pointer;
    position: absolute;
    z-index: 2;
    margin: auto;
    bottom: 0;
    top: 0;
}

/* 保存到云文字 和 下载文字 */
.image_saver_view_img:hover>.text_upload,
.image_saver_view_img:hover>.text_download {
    display: block;
    cursor: pointer;
    position: absolute;
    z-index: 1;
    bottom: 95px;
    color: #FFF;
    width: 50%;
    font-size: 14px;
    text-align: center;
}

/* 竖版 */
.image_saver_view_imgs[data-ivs=Y] .image_saver_view_img:hover>.text_upload,
.image_saver_view_imgs[data-ivs=Y] .image_saver_view_img:hover>.text_download {
    bottom: 190px;
}

/* 下载文字 */
.image_saver_view_img:hover>.text_download {
    right: 0;
}

/* 保存到云图标 */
.image_saver_view_img>.save {
    background-size: 40px;
    background-image: url('../../assets/images/imageSaver/saveToCloud.svg');
    left: 0;
}

.image_saver_view_img>.save:hover {
    background-size: 50px;
    background-image: url('../../assets/images/imageSaver/saveToCloudHover.svg');
}

.image_saver_view_img>.save:active {
    background-size: 40px;
    background-image: url('../../assets/images/imageSaver/saveToCloudActive.svg');
}

/* 下载图标 */
.image_saver_view_img>.download {
    background-size: 40px;
    background-image: url('../../assets/images/imageSaver/download.svg');
    right: 0;
}

.image_saver_view_img>.download:hover {
    background-size: 50px;
    background-image: url('../../assets/images/imageSaver/downloadHover.svg');
}

.image_saver_view_img>.download:active {
    background-size: 40px;
    background-image: url('../../assets/images/imageSaver/downloadActive.svg');
}

/* 视频图标 */
.image_saver_view_img>.type_video {
    width: 21px;
    height: 21px;
    background-image: url('../../assets/images/imageSaver/typeVideo.svg');
    display: block;
    position: absolute;
    z-index: 2;
    top: 16px;
    right: 16px;
}

/* 视频加载图标 */
.image_saver_view_img:hover>.type_video {
    background-size: 20px;
    background-repeat: no-repeat;
    animation: rotating 2s linear infinite;
    background-image: url('../../assets/images/imageSaver/loading2x.png');
}

/* 视频加载图标，已加载出来就不显示 */
.image_saver_view_img[data-canplay=yes]>.type_video {
    display: none;
}

/* 视频预览 */
.image_saver_view_img:hover>.video_preview {
    width: 100%;
    height: 100%;
    display: block;
    background-color: rgba(0,0,0,1);
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
}

/* 预览失败 */
.image_saver_view_img[data-status=error]>.preview_error {
    display: none;
}

/* Instagram图片加载成功后不显示骨架 */
.image_saver_view_img[data-status=success]>.skeleton {
    display: none;
}

/* 上一页 */
.page_up {
    text-align: center;
    padding: 20px 0;
}

/* 上一页按钮 */
.page_up_btn {
    color: #5562B4;
    background: #f2f7fe;
    font-weight: bolder;
    width: 262px;
    height: 40px;
    border-radius: 8px;
    border: none;
}

/* 上一页按钮，鼠标*/
.page_up_btn:hover {
    background: #e6eefa;
}

/* 上一页按钮，点击 */
.page_up_btn:active {
    background: #dce7f5;
}

/* 加载更多外框 */
.load_more_box {
    float: left;
    width: 100%;
    padding: 40px 0;
    text-align: center;
}

/* 加载更多按钮 */
.loadMore {
    width: 262px;
    height: 40px;
    padding: 10px 80px;
    border-radius: 8px;
    border: none;
    color: #5562B4;
    background: #F2F7FE;
    border-color: #F2F7FE;
    font-weight: bolder;
}

/* 加载更多按钮动作背景颜色 */
.loadMore:hover {
    background: #E6EEFA;
}

/* 加载更多按钮动作背景颜色 */
.loadMore:active {
    background: #DCE7F5;
}

/* 加载更多按钮，对齐 */
.loadMore>* {
    vertical-align: middle;
    margin: 0 2px;
}

/* 没有图片外框 */
.image_saver_view_blank {
    overflow: hidden;
    position: relative;
    background-color: #FFF;
    transition: height 0.3s;
}

/* 没有图片中间内容 */
.image_saver_view_blank_body {
    width: 100%;
    height: 226px;
    text-align: center;
    position: absolute;
    margin: auto;
    z-index: 1;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
}

/* 没有图片大文字 */
.image_saver_view_blank_body_text {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin: 20px auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: calc(100% - 600px);
}

/* 没有图片大文字，域名文字 */
.image_saver_view_blank_body_text>span {
    color: #5562B4;
}

/* 没有图片小文字 */
.image_saver_view_blank_body_dest {
    font-size: 16px;
    color: #6F6F6F;
}

/* 旋转 */
.my_animation {
    animation: rotating 2s linear infinite;
}

/* Instagram卡片 */
.ins_card {
    width: 100%;
    padding: 10px 10px 0px 10px;
    box-sizing: border-box;
    margin-top: 30px;
    text-align: center;
}

/* 头像外框 */
.ins_card_user_icon {
    width: 180px;
    height: 180px;
    border-radius: 90px;
    overflow: hidden;
    display: inline-block;
    position: relative;
    vertical-align: middle;
}

/* 头像图片 */
.ins_card_user_icon>img {
    width: 180px;
    height: 180px;
}

/* 默认不显示保存头像和下载头像 */
.ins_card_user_icon>div {
    display: none;
}

/* 指上去显示保存头像和下载头像 */
.ins_card_user_icon:hover>div {
    display: block;
}

/* 头像蒙版 */
.ins_card_mask {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
}

/* 头像下载和保存 */
.ins_card_icon_save,
.ins_card_icon_download {
    position: absolute;
    z-index: 2;
    top: 70px;
    width: 80px;
    height: 70px;
    font-size: 11px;
    color: #FFFFFF;
    background-repeat: no-repeat;
    line-height: 90px;
    text-align: center;
    cursor: pointer;
}

/* 头像上传，图标 */
.ins_card_icon_save {
    left: 10px;
    background-size: 30px;
    background-position: center 0px;
    background-image: url('../../assets/images/imageSaver/saveToCloud.svg');
}

/* 头像上传，动作 */
.ins_card_icon_save:hover {
    background-size: 39px;
    background-position: center -3px;
    background-image: url('../../assets/images/imageSaver/saveToCloudHover.svg');
}

/* 头像上传，点击 */
.ins_card_icon_save:active {
    background-size: 30px;
    background-position: center 0px;
    background-image: url('../../assets/images/imageSaver/saveToCloudActive.svg');
}

/* 头像下载，图标 */
.ins_card_icon_download {
    right: 10px;
    background-size: 30px;
    background-position: center 0px;
    background-image: url('../../assets/images/imageSaver/download.svg');
}

/* 头像下载，动作 */
.ins_card_icon_download:hover {
    background-size: 37px;
    background-position: center -4px;
    background-image: url('../../assets/images/imageSaver/downloadHover.svg');
}

/* 头像下载，点击 */
.ins_card_icon_download:active {
    background-size: 30px;
    background-position: center 0px;
    background-image: url('../../assets/images/imageSaver/downloadActive.svg');
}

/* Instagram用户信息 */
.ins_card_user_info {
    width: 340px;
    height: 180px;
    display: inline-block;
    text-align: left;
    margin-left: 40px;
    vertical-align: middle;
}

/* Instagram用户名 */
.ins_card_username {
    height: 32px;
    margin-top: 14px;
    font-size: 28px;
    font-weight: bold;
}

/* Instagram统计 */
.ins_card_user_count {
    height: 42px;
    padding: 30px 0;
    white-space: nowrap;
}

/* 统计文字 */
.ins_card_user_count>div {
    display: inline-block;
    text-align: center;
}

/* 数字 */
.ins_card_user_num {
    height: 20px;
}

/* 类型文字 */
.ins_card_user_text {
    height: 22px;
    line-height: 26px;
}

/* 统计左右间距 */
.ins_card_user_followers {
    margin: 0 60px;
}

/* Instagram按钮框 */
.ins_card_btns {
    white-space: nowrap;
}

/* Instagram按钮 */
.ins_card_save_all,
.ins_card_downlad_all {
    display: inline-block;
    background-color: #5562B4;
    border-radius: 4px;
    padding-left: 44px;
    padding-right: 20px;
    font-size: 14px;
    color: #FFFFFF;
    height: 32px;
    line-height: 32px;
    background-repeat: no-repeat;
    background-position: 20px center;
    cursor: pointer;
}

/* Instagram按钮，动作 */
.ins_card_save_all:hover,
.ins_card_downlad_all:hover {
    background-color: #3F4A8D;
}

/* Instagram按钮，点击 */
.ins_card_save_all:active,
.ins_card_downlad_all:active {
    background-color: #293166;
}

/* Instagram保存所有 */
.ins_card_save_all {
    background-image: url('../../assets/images/imageSaver/cardSaveAll.svg');
}

/* Instagram下载所有 */
.ins_card_downlad_all {
    margin-left: 18px;
    background-image: url('../../assets/images/imageSaver/cardDownloadAll.svg');
}

/* 没有分类时的间隔 */
.ins_card_types_no {
    height: 30px;
}

/* Instagram下面的类型 */
.ins_card_types {
    margin-top: 30px;
    border-top: 1px solid #C1CBE3;
}

/* Instagram类型 */
.ins_card_types>div {
    height: 16px;
    line-height: 16px;
    display: inline-block;
    margin: 0px 30px;
    padding-top: 30px;
    padding-left: 21px;
    padding-bottom: 10px;
    color: #6F6F6F;
    font-size: 14px;
    border-top: 2px solid transparent;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: 0px 30px;
    position: relative;
}

.ins_card_types>div.select {
    border-top: 2px solid #5562B4;
    color: #5562B4;
}

/* Instagram类型，贴子 */
.ins_card_type_posts {
    background-image: url('../../assets/images/imageSaver/insTypePosts.svg');
}
.ins_card_type_posts.select {
    background-image: url('../../assets/images/imageSaver/insTypePostsSelect.svg');
}

/* Instagram类型，视频 */
.ins_card_type_reels {
    background-image: url('../../assets/images/imageSaver/insTypeReels.svg');
}
.ins_card_type_reels.select {
    background-image: url('../../assets/images/imageSaver/insTypeReelsSelect.svg');
}

/* Instagram类型，故事 */
.ins_card_type_stories {
    background-image: url('../../assets/images/imageSaver/insTypeStories.svg');
}
.ins_card_type_stories.select {
    background-image: url('../../assets/images/imageSaver/insTypeStoriesSelect.svg');
}

/* Instagram类型，突出故事 */
.ins_card_type_highlights {
    background-image: url('../../assets/images/imageSaver/insTypeHighlights.svg');
}
.ins_card_type_highlights.select {
    background-image: url('../../assets/images/imageSaver/insTypeHighlightsSelect.svg');
}

/* Ins附加，加载中 */
.ins_sub_loading {
    position: relative;
}

/* Ins附加，加载中图标 */
.ins_sub_loading_icon {
    width: 96px;
    height: 96px;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('../../assets/images/imageSaver/bigLoading.svg');
    animation: rotating 2s linear infinite;
    position: absolute;
    margin: auto;
    z-index: 1;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
}

/* 小屏加载图标 */
@media (max-width: 1920px) {
  .ins_sub_loading_icon {
    background-size: 60%;
  }
}

/* 禁止点击按钮 */
.ins_card[data-error=Y] .ins_card_btns>div,
.ins_card[data-loading=Y] .ins_card_btns>div {
    background-color: #9DA8D3;
    cursor: default;
}

/* 附加数据，加载失败 */
.ins_sub_error {
    min-height: 300px;
    position: relative;
}

/* 附加数据，加载失败内容 */
.ins_sub_error_content {
    width: 400px;
    height: 120px;
    text-align: center;
    position: absolute;
    margin: auto;
    z-index: 1;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
}

/* 附加数据，加载失败图标 */
.ins_sub_error_content>img {
    width: 100px;
}

/* 附加数据，加载失败文字 */
.ins_sub_error_content>div {
    color: #6F6F6F;
    font-size: 14px;
    padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/image_saver_view.vue